import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;
declare let WizRoute: any;

@Component({
    standalone: false,
    selector: 'wiz-page-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAdminComponent implements OnInit, OnDestroy {
    public tab: string = 'members';
    public loading: boolean = false;
    public tabs: any[] = [
        {
            key: 'members',
            label: '멤버 관리',
            desc: '계정, 역할, 가입 상태를 관리합니다.',
            href: '/admin/members'
        },
        {
            key: 'projects',
            label: '프로젝트 관리',
            desc: '전체 사용자 프로젝트와 산출물 흐름을 확인합니다.',
            href: '/admin/projects'
        },
        {
            key: 'llm',
            label: 'LLM 모델',
            desc: 'Ollama 서버 연결과 활성 모델을 관리합니다.',
            href: '/admin/llm'
        }
    ];
    public roleOptions: any[] = [
        { value: '', label: '전체 역할' },
        { value: 'admin', label: 'Admin' },
        { value: 'user', label: 'User' },
        { value: 'editor', label: 'Editor' },
        { value: 'viewer', label: 'Viewer' }
    ];
    public statusOptions: any[] = [
        { value: '', label: '전체 상태' },
        { value: 'draft', label: '초안' },
        { value: 'in_progress', label: '진행중' },
        { value: 'completed', label: '완료' }
    ];
    public memberSearch: any = { text: '', role: '' };
    public projectSearch: any = { text: '', status: '', owner: '' };
    public members: any[] = [];
    public ownerOptions: any[] = [];
    public projects: any[] = [];
    public memberStats: any = { total: 0, admins: 0, projects: 0, reports: 0 };
    public projectStats: any = { total: 0, draft: 0, inProgress: 0, completed: 0 };
    public projectError: string = '';
    public llmOverview: any = {
        host: '',
        health: { connected: false, version: '', message: '' },
        active: null,
        stats: { total: 0, available: 0, missing: 0 },
        promptTests: [],
        auditLogs: []
    };
    public llmModels: any[] = [];
    public llmLoading: boolean = false;
    public llmAction: string = '';
    public llmError: string = '';
    public llmTestResult: any = null;
    public llmRegressionResult: any = null;
    private routerSub: any = null;
    private keepProjectOwnerFilter: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.syncTab();
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                await this.syncTab();
                await this.service.render();
            }
        });
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    public async syncTab() {
        const nextTab = this.routeTab();
        if (!this.isKnownTab(nextTab)) {
            this.service.href('/admin/members');
            return;
        }
        const changed = this.tab !== nextTab;
        this.tab = nextTab;
        if (changed || this.currentItems().length === 0) {
            await this.loadCurrent();
        }
    }

    public routeTab() {
        const parts = location.pathname.replace(/\/+$/, '').split('/').filter(Boolean);
        const adminIndex = parts.lastIndexOf('admin');
        if (adminIndex >= 0 && parts[adminIndex + 1]) return parts[adminIndex + 1];
        return WizRoute?.segment?.tab || 'members';
    }

    public isKnownTab(tab: string) {
        return this.tabs.some((item: any) => item.key === tab);
    }

    public activeClass(tab: string) {
        if (this.tab === tab) {
            return 'border-slate-950 bg-slate-950 text-white shadow-sm';
        }
        return 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50';
    }

    public async go(tab: string) {
        if (!this.isKnownTab(tab)) return;
        if (tab === 'projects') {
            this.projectSearch.owner = '';
            this.keepProjectOwnerFilter = false;
        }
        this.service.href(`/admin/${tab}`);
        await this.service.render();
    }

    public currentItems() {
        if (this.tab === 'members') return this.members;
        if (this.tab === 'projects') return this.projects;
        if (this.tab === 'llm') return this.llmModels;
        return [];
    }

    public async loadCurrent() {
        if (this.tab === 'members') {
            await this.loadMembers();
            return;
        }
        if (this.tab === 'llm') {
            await this.loadLLM();
            return;
        }
        await this.loadProjects();
    }

    public tabTitle() {
        const found = this.tabs.find((item: any) => item.key === this.tab);
        return found ? found.label : '관리자 페이지';
    }

    public tabDesc() {
        const found = this.tabs.find((item: any) => item.key === this.tab);
        return found ? found.desc : '';
    }

    public async loadMembers() {
        this.loading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('members', this.memberSearch);
            if (code === 200) {
                const payload = this.payload(data);
                this.members = payload.items || [];
                this.memberStats = payload.stats || this.memberStats;
            }
        } catch (error) {
            this.members = [];
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadProjects() {
        this.loading = true;
        this.projectError = '';
        await this.service.render();
        try {
            if (!this.keepProjectOwnerFilter && this.projectSearch.owner && this.tab === 'projects') {
                this.projectSearch.owner = '';
            }
            this.keepProjectOwnerFilter = false;
            try {
                const memberRes = await wiz.call('members', { text: '', role: '' });
                if (memberRes && memberRes.code === 200) {
                    const memberPayload = this.payload(memberRes.data);
                    this.ownerOptions = (memberPayload && memberPayload.items) || [];
                    if (this.members.length === 0) {
                        this.members = this.ownerOptions;
                        this.memberStats = (memberPayload && memberPayload.stats) || this.memberStats;
                    }
                }
            } catch (e) { /* 멤버 로딩 실패는 무시 */ }
            const res = await wiz.call('projects', this.projectSearch);
            const code = res ? res.code : -1;
            const data = res ? res.data : null;
            if (code === 200) {
                const payload = this.payload(data);
                this.projects = (payload && payload.items) || [];
                this.projectStats = (payload && payload.stats) || this.projectStats;
            } else {
                this.projects = [];
                this.projectStats = { total: 0, draft: 0, inProgress: 0, completed: 0 };
                this.projectError = this.errorMessage(data, '프로젝트 목록을 불러오지 못했습니다.');
            }
        } catch (error: any) {
            this.projects = [];
            this.projectStats = { total: 0, draft: 0, inProgress: 0, completed: 0 };
            this.projectError = (error && error.message) || '프로젝트 목록을 불러오는 중 오류가 발생했습니다.';
            console.error('[admin/projects]', error);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public payload(data: any) {
        if (!data) return {};
        return data.data || data;
    }

    public errorMessage(data: any, fallback: string) {
        if (!data) return fallback;
        if (typeof data === 'string') return data;
        return data.message || data.error || fallback;
    }

    public async setRole(role: string) {
        this.memberSearch.role = role;
        await this.loadMembers();
    }

    public async setStatus(status: string) {
        this.projectSearch.status = status;
        await this.loadProjects();
    }

    public async setOwner(owner: string) {
        this.projectSearch.owner = owner;
        this.keepProjectOwnerFilter = true;
        await this.loadProjects();
    }

    public async openMemberProjects(member: any) {
        this.projectSearch.owner = member.id;
        this.keepProjectOwnerFilter = true;
        this.service.href('/admin/projects');
        this.tab = 'projects';
        await this.loadProjects();
    }

    public async transferProject(project: any, ownerId: string) {
        if (!project || !ownerId || project.ownerId === ownerId) return;
        const previousOwner = project.ownerId;
        project.ownerId = ownerId;
        await this.service.render();
        const { code, data } = await wiz.call('transfer_project', { project_id: project.id, owner_id: ownerId });
        if (code === 200) {
            await this.loadProjects();
            if (this.tab === 'members') await this.loadMembers();
            return;
        }
        project.ownerId = previousOwner;
        await this.service.modal.error(data || '소유자 변경에 실패했습니다.');
        await this.service.render();
    }

    public applyLLMOverview(data: any) {
        const payload = this.payload(data);
        this.llmOverview = payload || this.llmOverview;
        this.llmModels = (payload && payload.items) || [];
    }

    public async loadLLM() {
        this.llmLoading = true;
        this.llmError = '';
        await this.service.render();
        try {
            const res = await wiz.call('llm_overview');
            if (res.code === 200) {
                this.applyLLMOverview(res.data);
            } else {
                this.llmError = this.errorMessage(res.data, 'LLM 서버 정보를 불러오지 못했습니다.');
            }
        } catch (error: any) {
            this.llmError = (error && error.message) || 'LLM 서버 정보를 불러오는 중 오류가 발생했습니다.';
        } finally {
            this.llmLoading = false;
            await this.service.render();
        }
    }

    public async syncLLM() {
        this.llmAction = 'sync';
        this.llmError = '';
        await this.service.render();
        try {
            const res = await wiz.call('llm_sync');
            if (res.code === 200) {
                this.applyLLMOverview(res.data);
            } else {
                this.llmError = this.errorMessage(res.data, '모델 목록 동기화에 실패했습니다.');
            }
        } catch (error: any) {
            this.llmError = (error && error.message) || '모델 목록 동기화 중 오류가 발생했습니다.';
        } finally {
            this.llmAction = '';
            await this.service.render();
        }
    }

    public async activateLLM(model: any) {
        if (!model || model.active) return;
        this.llmAction = `activate:${model.name}`;
        this.llmError = '';
        await this.service.render();
        try {
            const res = await wiz.call('llm_activate', { model: model.name });
            if (res.code === 200) {
                this.applyLLMOverview(res.data);
            } else {
                this.llmError = this.errorMessage(res.data, '활성 모델 변경에 실패했습니다.');
            }
        } catch (error: any) {
            this.llmError = (error && error.message) || '활성 모델 변경 중 오류가 발생했습니다.';
        } finally {
            this.llmAction = '';
            await this.service.render();
        }
    }

    public async pullLLM(model: any) {
        if (!model) return;
        this.llmAction = `pull:${model.name}`;
        this.llmError = '';
        await this.service.render();
        try {
            const res = await wiz.call('llm_pull', { model: model.name });
            if (res.code === 200) {
                this.applyLLMOverview(res.data);
            } else {
                this.llmError = this.errorMessage(res.data, '모델 다운로드 요청에 실패했습니다.');
            }
        } catch (error: any) {
            this.llmError = (error && error.message) || '모델 다운로드 요청 중 오류가 발생했습니다.';
        } finally {
            this.llmAction = '';
            await this.service.render();
        }
    }

    public async testLLM(model: any) {
        if (!model) return;
        this.llmAction = `test:${model.name}`;
        this.llmTestResult = null;
        this.llmError = '';
        await this.service.render();
        try {
            const res = await wiz.call('llm_test', { model: model.name });
            if (res.code === 200) {
                this.llmTestResult = res.data || {};
            } else {
                this.llmError = this.errorMessage(res.data, '모델 테스트에 실패했습니다.');
            }
        } catch (error: any) {
            this.llmError = (error && error.message) || '모델 테스트 중 오류가 발생했습니다.';
        } finally {
            this.llmAction = '';
            await this.service.render();
        }
    }

    public async runLLMRegression() {
        this.llmAction = 'regression';
        this.llmRegressionResult = null;
        this.llmError = '';
        await this.service.render();
        try {
            const res = await wiz.call('llm_regression', { model: this.llmOverview.active?.name || '' });
            if (res.code === 200) {
                this.llmRegressionResult = res.data || {};
                this.llmOverview.promptTests = this.llmRegressionResult.tests || this.llmOverview.promptTests || [];
                this.llmOverview.auditLogs = this.llmRegressionResult.auditLogs || this.llmOverview.auditLogs || [];
            } else {
                this.llmError = this.errorMessage(res.data, '프롬프트 회귀 테스트에 실패했습니다.');
            }
        } catch (error: any) {
            this.llmError = (error && error.message) || '프롬프트 회귀 테스트 중 오류가 발생했습니다.';
        } finally {
            this.llmAction = '';
            await this.service.render();
        }
    }

    public llmStatusLabel(status: string) {
        const labels: any = {
            available: '사용 가능',
            missing: '미설치',
            pulling: '다운로드 중',
            error: '오류',
            required: '필수'
        };
        return labels[status] || status || '-';
    }

    public llmStatusClass(status: string) {
        const classes: any = {
            available: 'bg-emerald-50 text-emerald-700 border-emerald-200',
            missing: 'bg-amber-50 text-amber-700 border-amber-200',
            pulling: 'bg-cyan-50 text-cyan-700 border-cyan-200',
            error: 'bg-red-50 text-red-700 border-red-200',
            required: 'bg-slate-50 text-slate-600 border-slate-200'
        };
        return classes[status] || 'bg-slate-50 text-slate-600 border-slate-200';
    }

    public roleClass(role: string) {
        const classes: any = {
            admin: 'bg-slate-950 text-white',
            user: 'bg-cyan-50 text-cyan-700',
            editor: 'bg-amber-50 text-amber-700',
            viewer: 'bg-slate-100 text-slate-600'
        };
        return classes[role] || 'bg-slate-100 text-slate-600';
    }

    public statusClass(status: string) {
        const classes: any = {
            draft: 'bg-amber-50 text-amber-700 border-amber-200',
            in_progress: 'bg-cyan-50 text-cyan-700 border-cyan-200',
            completed: 'bg-emerald-50 text-emerald-700 border-emerald-200'
        };
        return classes[status] || 'bg-slate-50 text-slate-600 border-slate-200';
    }
}

export default PageAdminComponent;